import createTableStore from "ds/components/Table/store/useTableStore";

import {
  WEBHOOK_DELIVERIES_TABLE_COLUMNS_CONFIG,
  WEBHOOK_DELIVERIES_TABLE_STORAGE_KEY,
} from "./constants";

const useWebhookDeliveriesTableStore = createTableStore({
  storageKey: WEBHOOK_DELIVERIES_TABLE_STORAGE_KEY,
  config: WEBHOOK_DELIVERIES_TABLE_COLUMNS_CONFIG,
});

export default useWebhookDeliveriesTableStore;
